<section (click)="clicked()" class="book-modal-clickable-label__container flex row justify-content-between">
  <p class="book-modal-clickable-label__text">{{ labelText }}</p>
  <a class="book-modal-clickable-label__icon"> <img src="assets/images/icons/arrow-right-light.svg" /></a>
</section>
